import { render } from "./F2Form.vue?vue&type=template&id=2a91ede0&ts=true"
import script from "./F2Form.vue?vue&type=script&lang=ts"
export * from "./F2Form.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__